import { CommonApi } from '@/api/common';
import { APIResponse } from './../interface/index';
import { isAuditStatus, getQueryString } from './util'
import { reactive, ref, computed } from 'vue'

/**
 *
 * @param config
 * emergency_close 财产集市紧急关闭 1:关闭 0:未关闭
 * platform_upgrade: 1 平台升级中。0 正常
 * @returns
 */
export const handleConfig = (config: any) => {
  if (+config.platform_upgrade === 1) {
    uni.reLaunch({
      url: '/pages/common/maintain'
    })
    return
  }
}
/**
 *
 * @param url
 * @returns
 */
export const checkLogin = (url: string) => {
  const getUserInfo = uni.getStorageSync('userInfo')
  let token = getUserInfo.token
  if (!token) {
    return uni.navigateTo({
      url: '/pages/login/index'
    })
  }
  uni.navigateTo({ url })
}

// 设置tabbar
export const setTabbar = async () => {
  let temp = await isAuditStatus()
  if (temp) {
    // #ifdef APP-PLUS
    uni.setTabBarItem({
      index: 1,
      visible: false
    })
    uni.setTabBarItem({
      index: 2,
      visible: false
    })
    // #endif
    // #ifdef H5
    uni.setTabBarItem({
      index: 2,
      visible: true
    })
    // #endif
  } else {
    // #ifdef APP-PLUS
    uni.setTabBarItem({
      index: 1,
      visible: true
    })
    uni.setTabBarItem({
      index: 2,
      visible: true
    })
    // #endif
    // #ifdef H5
    uni.setTabBarItem({
      index: 2,
      visible: true
    })
    // #endif
  }
}

/**
 *  人脸认证（无痕验证，非无痕验证不可用）
 * @param url
 * @returns
 */
export const faceAuth = (nvcData: any, nVerify?: any) => {
  //  #ifdef APP-PLUS
  return new Promise(async (resolve, reject) => {
    let n: any = null
    if (nVerify) {
      n = nVerify
    } else {
      n = uni.requireNativePlugin('AP-FaceDetectModule')
    }
    const isIosApp = computed(() => {
      return uni.getSystemInfoSync().platform === 'ios'
    })
    console.log('---------AP-FaceDetectModule------', n)
    const verifyC = (certifyId) => {
      n.verify(
        {
          certifyId
        },
        function (t) {
          console.log("verifyC1111", t)
          if (t.code === 1000) {  // 验证成功需调一下查询人脸认证接口，以便更新结果（音效）
            try {
              CommonApi.loadCertifyResult({ certify_id: certifyId }).then((res: any) => {
                console.log(" CommonApi.loadCertifyResult", res)
                if (res && !res.code) {
                  resolve({
                    is_success: res.data.is_success, // 0失败 1成功
                    res: t,
                    certifyId: certifyId
                  })
                }
              })
            } catch (error) {
              console.log(error)
              reject(error)
            }
          } else {
            // 失败
            resolve({
              res: t,
              certifyId: certifyId
            })
          }

        }
      )
    }
    // 获取certify_id
    const loadCertifyUriPro = async (t) => {
      let params
      if (isIosApp.value) {
        params = JSON.stringify(t)
      } else {
        params = t
      }
      console.log('loadCertifyUriProPro1111---', params, nvcData)
      try {
        const res = (await CommonApi.loadCertifyUriPro({ meta_info: params, data: nvcData })) as APIResponse
        console.log('loadCertifyUriProPro2222--', res)
        if (res && !res.code) {
          uni.hideLoading()
          if (res.data.certify_id) {
            console.log('loadCertifyUriProPro333333--', res.data.certify_id)
            setTimeout(() => {
              console.log('loadCertifyUriProPro44444--', res.data.certify_id)
              verifyC(res.data.certify_id)
            }, 100)
          }
        } else {
          reject()
        }
      } catch (error) {
        uni.hideLoading()
        console.log('error', error)
        reject(error)
      }
    }
    //获取环境参数接口。
    const getMetaInfo = () => {
      uni.showLoading({
        title: '加载中',
        mask: true
      })
      let t = n.getMetaInfo()
      loadCertifyUriPro(t)
    }
    getMetaInfo()
  })
  // #endif
}
